export default "__VITE_ASSET__WJa$IlXc__"